import { RangerSourceMapService } from './ranger-source-map.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { RANGER_SOURCE_MAP_TYPE, RangerSourceMap } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class RangerSourceMapResolverBase implements Resolve<RangerSourceMap> {

  constructor(protected service: RangerSourceMapService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RangerSourceMap> {
    const key: string = RANGER_SOURCE_MAP_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



